import { useIntl } from 'react-intl';

import { Typography } from '../../../design-system/components/typography/Typography';
import { Author } from '../../../resources/author/domain/types/author';
import { PickDomain } from '../../utilities/types/PickDomain';

import { AuthorBanner } from './AuthorBanner/AuthorBanner';

import style from './AuthorBannerSection.module.css';

type AuthorBannerSectionProps = {
    author: PickDomain<
        Author,
        'id' | 'firstName' | 'lastName' | 'picture' | 'role' | 'description' | 'slug',
        {
            linkedinUrl: Author['linkedinUrl'] | null;
            instagramUrl: Author['instagramUrl'] | null;
        }
    >;
};

export function AuthorBannerSection({ author }: AuthorBannerSectionProps) {
    const { formatMessage } = useIntl();
    return (
        <div className={style.container}>
            <Typography scale="primary-s-extra-bold">
                {formatMessage({ id: 'page.author.DownBloc.title' })}
            </Typography>
            <AuthorBanner author={author} />
        </div>
    );
}
